

export default {

};



// WEBPACK FOOTER //
// ./src/store/modules/box/mutations.js